import { ChangeDetectionStrategy, Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ChangableComponent } from '@app/models/changable.component';
import { getLibraryRouteData } from '@app/store/reducers/library.reducer';
import { AccountService, ContextService } from '@core/services';
import { Store } from '@ngrx/store';
import { User } from 'lingo2-models';
import { DeviceDetectorService } from 'ngx-device-detector';
import { filter, mergeMap, takeUntil } from 'rxjs';
import { LibrarySidebarService } from './library-sidebar.service';

@Component({
  selector: 'app-library-sidebar',
  templateUrl: './library-sidebar.component.html',
  styleUrls: ['./library-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LibrarySidebarComponent extends ChangableComponent implements OnInit {
  private readonly sidebarService = inject(LibrarySidebarService);
  private readonly accountService = inject(AccountService);
  private readonly contextService = inject(ContextService);
  private readonly store = inject(Store);
  deviceService = inject(DeviceDetectorService);
  private platformId = inject(PLATFORM_ID);

  public useFilter$ = this.sidebarService.useFilter$;
  public contentPage$ = this.sidebarService.contentPage$;
  public user: User;
  public me: User;

  ngOnInit() {
    this.sidebarService.user$
      .pipe(
        filter((user) => !!user),
        mergeMap((user) => this.accountService.getUserById(user.id, 'LOAD_TIME')),
        takeUntil(this.destroyed$),
      )
      .subscribe({
        next: (_user) => {
          this.user = _user;
          this.detectChanges();
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
        },
      });

    this.contextService.me$.pipe(takeUntil(this.destroyed$)).subscribe({
      next: (me) => (this.me = me),
      error: (error) => {
        this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
      },
    });

    this.store
      .select(getLibraryRouteData)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (data) => {
          this.detectChanges();
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
        },
      });
  }
}
